import { ReactElement, useState } from 'react';

import { Icon, Snackbar } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';

import { ServiceContent } from '../ServiceContent';

import styles from './styles.module.scss';

import { Link } from ':components';
import { ServiceItem } from ':types';
import { trackEvent, isMobile } from ':utils';

const analyticsServiceClickHandler =
  (service: string, callback?: () => void) => () => {
    trackEvent('CatalogServices', {
      service,
      isMobile: isMobile ? 'Mobile' : 'Desktop',
    });
    callback?.();
  };

export function ServiceComponent({
  alias,
  is_under_construction,
  type,
  url = '',
  ...rest
}: ServiceItem): ReactElement {
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const handleOpenSnackbar = (): void => setIsOpenSnackbar(true);
  const handleCloseSnackbar = (): void => setIsOpenSnackbar(false);

  const isInternal = type === 'internal';
  const fixedURL = isInternal && !url.startsWith('/') ? `/${url}` : url;

  if (is_under_construction) {
    return (
      <>
        <button
          onClick={analyticsServiceClickHandler(alias, handleOpenSnackbar)}
          className={styles.button}
        >
          <ServiceContent {...rest} />
        </button>
        <Snackbar
          variant='elastic'
          horizontal='center'
          open={isOpenSnackbar}
          onClose={handleCloseSnackbar}
          message='Этот сервис еще не запущен, но мы работаем над этим'
        />
      </>
    );
  }

  return (
    <Link
      to={fixedURL}
      noWrapper
      disableTextDecoration
      className={styles.link}
      onClick={analyticsServiceClickHandler(alias)}
    >
      <ServiceContent
        arrowIcon={
          <Icon
            size='medium'
            iconName={isInternal ? Icons.ArrowRight : Icons.OpenInWindow}
            className={styles.icon}
          />
        }
        {...rest}
      />
    </Link>
  );
}
